import React from "react";
import { IonSlides, IonSlide } from "@ionic/react";
import { map, get } from 'lodash';
import styled from "styled-components";
import "@ionic/react/css/core.css";
import { colors } from '../helpers';
const IonSlidesWrapper = styled(IonSlides) `
  --bullet-background-active: ${props => props.bulletColor};
`;
const SlideItem = styled.div `
  height: 30vh;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  position: relative;
`;
const SlideItemShadow = styled.span `
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: end;
  -ms-flex-align: end;
  align-items: flex-end;
  justify-content: center;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  height: 90%;
  padding-bottom: 1.6em;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  position: absolute;
  text-shadow: 0 1px 4px rgba(0,0,0,.08);
  background: linear-gradient(180deg,transparent 50%,rgba(0,0,0,.1));
`;
const slideOpts = {
    initialSlide: 0,
    speed: 400,
    autoplay: {
        delay: 5000,
    },
};
export const Slide = ({ data, theme, }) => {
    return (React.createElement(IonSlidesWrapper, { key: data.pictures.join(''), bulletColor: colors[get(theme, 'color.title')], pager: true, options: slideOpts }, map(data.pictures, picture => {
        return (React.createElement(IonSlide, null,
            React.createElement(SlideItem, { key: picture, style: {}, picture: picture },
                React.createElement("img", { src: picture, style: {
                        position: 'absolute',
                        height: '100%',
                        width: '100%'
                    }, alt: "" }),
                React.createElement(SlideItemShadow, null))));
    })));
};
